var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('slide-dialog',{attrs:{"visible":_vm.detailModel},on:{"update:visible":function($event){_vm.detailModel=$event},"opened":_vm.dialogOpen,"close":_vm.dialogClose}},[_c('task-detail',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"taskDetail",attrs:{"dialog":"","taskId":_vm.taskId}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c0c85eb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reuse/dialog/task/detail.vue
// module id = null
// module chunks = 